import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'
import { environment } from 'src/environments/environment'
import { ActivatedRoute, Router } from '@angular/router';
import { GeolocationService } from '../services/geolocationservice';
import { sweetalert } from "../services/sweetalert";
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-shop-online',
  templateUrl: './shop-online.component.html',
  styleUrls: ['./shop-online.component.css']
})
export class ShopOnlineComponent implements OnInit {
  response: any;
  custid: any;
  mobile: any;
  loader: boolean;
  responseData: any;
  filtersLoaded: Promise<boolean>;
  reDirUrl: any;
  port: any;
  reqData: any;
  brandName: any;
  brandUrl: any;
  electronicList = [];
  list = [];
  flipKart: any;
  travelList: any;
  educationList: any;
  customer_id: any;
  mobile_no: any;
  lat: any;
  lng: any;
  selectedCategory:any;
  selectedCategoryList:any;
  brandList=[];

  mainList=[];
  selectedHelperData: any;
  helperList: any;
  helperObj: any;

  constructor(private service: GeolocationService,
    private activatedRoute: ActivatedRoute,
    private alert: sweetalert,
    private httpClient: HttpClient,
    private router: Router,
    @Inject(DOCUMENT) private document: any) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {

      this.reqData = params['data'] ? params['data'] : null;
      this.lat = params["lat"] != null ? params["lat"] : null;
      this.lng = params["lng"] != null ? params["lng"] : null;

      console.log('lat:' + this.lat);
      console.log('lng:' + this.lng);
      if (typeof this.reqData !== 'object' && this.reqData !== null) {
        this.reqData = JSON.parse(this.reqData);
        this.customer_id = this.reqData.customer_id;
        this.mobile_no = this.reqData.mobile_no;
      }
      console.log('reqData:' + JSON.stringify(this.reqData));

      error => {

        console.error("Unable to Process")

      }
    });

    if (this.reqData != null) {

      //this.reqData = JSON.parse(this.reqData);
      let reqObject = {
        customer_id: `${this.reqData.customer_id}`,
        mobile_no: `${this.reqData.mobile_no}`,
        redirURL: `${this.reqData.redirURL}`,
        system: `${this.reqData.system}`,
        lat: `${this.lat}`,
        lng: `${this.lng}`
      }

      this.service.getUrl(reqObject).subscribe(
        (data: any) => {

          this.loader = true;
          if (typeof (data) === 'object') {
            this.responseData = JSON.parse(data.data);
            console.log("response:" + JSON.stringify(this.responseData))
            if (this.responseData.STATUS_CODE == 'ER') {
              this.alert.errorsweertalert(this.responseData.STATUS_MESSAGE);
              // setTimeout(() => {
              //   window.location.href = this.responseData.URL;
              // }, 3000);

            }
            else if (this.responseData.STATUS_CODE == 'SR' && (this.responseData.MFI_ELIGIBLE == 'N') && this.responseData.SYSTEM == 'SO') {
              this.loadPage();
              this.filtersLoaded = Promise.resolve(true);
              this.loader = false;
            }
            else if (this.responseData.STATUS_CODE == 'SR' && (this.responseData.MFI_ELIGIBLE == 'Y' || this.responseData.MFI_ELIGIBLE == 'N')) {
              window.location.href = this.responseData.URL;
            }
            else {
              this.loadPage();
              this.filtersLoaded = Promise.resolve(true);
              this.alert.errorsweertalert("Something went wrong");
              this.loader = false;
            }

          }
          this.loader = false;
        }
      );
    }
    else {
      this.loadPage();
      this.filtersLoaded = Promise.resolve(true);
    }


  }

  loadPage() {
    this.service.getOnlineShopUrl().subscribe((data: any) => {

      if (typeof (data) === 'object') {
        console.log("event:" + JSON.stringify(data));
        this.response = JSON.parse(data.data);
        
        this.mainList=this.response.MAIN_LIST;
        this.helperList=this.response.HELPER_LIST;
        this.mainList.sort((a,b)=>a.CATEGORY_ORDER - b.CATEGORY_ORDER);
        console.log(this.mainList);
        this.selectedCategory=this.mainList[0].CATEGORY_NAME;
        this.selectedCategoryList=this.getSelectedCategoryList(this.selectedCategory);

        if (data.statusCode == 'EX') {

          // this.loader = false;

        } else if (data.statusCode == 'SR') {
          //  this.loader = false;
        }

      }


    });
  }

  redirectUrl(data: any) {
    let obj = {
      custid: `${this.customer_id}`,
      mobile: `${this.mobile_no}`,
      brandname: `${data.BRAND_NAME}`,
      lat: `${this.lat}`,
      lng: `${this.lng}`
    }

    if (obj.custid && obj.mobile && obj.lat && obj.lng) {

      this.httpClient
        .post(environment.baseUrl + '/tvsm/saveShopOnlineLogs', obj)
        .toPromise().then(data => {
          console.log("data", data);
        });

    }
    if(data.BRAND_NAME=='flipkart' || data.BRAND_NAME=='Amazon'){
      this.selectedHelperData=this.helperList.filter(s => s.BRAND_NAME === data.BRAND_NAME);
      this.helperObj=this.selectedHelperData[0];
      console.log("this.helperObj:"+JSON.stringify(this.helperObj));
      localStorage.setItem('helperData', JSON.stringify(this.helperObj));
      localStorage.setItem('brandUrlForHelper',data.BRAND_URL);
      this.router.navigate(["helper-screen"]); 
    }
    else{
      window.location.href = data.BRAND_URL;
    }
  }

  getSelectedCategoryList(category: string) {
    this.selectedCategory = category;
    this.selectedCategoryList=this.mainList.filter(
      (e: { CATEGORY_NAME: string }) => e.CATEGORY_NAME == category
    );
  
    this.brandList=this.selectedCategoryList[0].BRAND_LIST;
    this.brandList.sort((a,b)=>a.BRAND_ORDER - b.BRAND_ORDER);

  }
}
